module.exports = __webpack_public_path__ + "static/media/Untitled-2.1bcbcb4b.png";